module.exports = __webpack_public_path__ + "static/media/truck.e16738d2.svg";